export class Privilege {

    Id :number;
    RoleId:   number; 
    MenuId :number;
    DocumentId :number;
    DocumentName:string;
    IsMenu: number;
    IsAdd: number;
    IsEdit: number;
    IsDelete: number;
    IsView : number;
    Title : string;
    TargetName: string;
    RouteUrl: string;
    Icon: string;

    IsActive: number;
    CreatedDate:Date;
    ModifiedDate:Date;

    CompanyId: number;
    EmployeeId: number;
    EmployeeBranchId: number;
    SaasId: string;

    ListByRoleId:boolean; 

}
